module.exports = __webpack_public_path__ + "img/ms_b1_img2.4df0c98a.png";